import Chips from '@app/domains/common/components/Chips';
import ChipsSwiper from '@app/domains/common/components/ChipsSwiper';
import { useId } from 'react';
import { SwiperSlide } from 'swiper/react';

type Props = {
    selectedGenre?: string;
    genres: string[] | undefined;
    onSelect?: (string) => void;
    isLoading?: boolean;
};
export default function HomeGenres({ selectedGenre, genres = Array(10).fill('temp'), onSelect, isLoading }: Props) {
    const id = useId();

    return (
        <ChipsSwiper gap={8} key={`genres-${id}-${isLoading ?? false}`}>
            {genres?.map((genre, idx) => (
                <SwiperSlide key={idx} className="!w-auto">
                    <Chips.Chip
                        label={genre}
                        onClick={() => {
                            onSelect?.(genre);
                        }}
                        selected={selectedGenre === genre}
                        className="font-set-sb13 md:font-set-sb16"
                        isLoading={isLoading}
                    />
                </SwiperSlide>
            ))}
        </ChipsSwiper>
    );
}
